import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as HydrationActions from './storage.actions';
import { PersistedState } from './storage.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Storage } from '../shared/storage';
import { AUTH_FEATURE_KEY, AuthState, initialState as AuthInitialState } from '../auth/store/auth.reducer';
import { DATA_FEATURE_KEY, DataState, initialState as DataInitialState } from './data.reducer';
import {
  EXERCISE_FEATURE_KEY,
  ExerciseState,
  initialState as ExerciseInitialState,
} from '../exercise/store/exercise.reducer';
import { CLIENT_FEATURE_KEY, ClientState, initialState as ClientInitialState } from '../client/store/client.reducer';
import { LoggerService } from '../shared/services/logger.service';

@Injectable()
export class StorageEffects {
  logger: LoggerService = inject(LoggerService);
  actions$: Actions = inject(Actions);

  hydrate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HydrationActions.hydrate),
      switchMap(() => {
        const persistedState: Partial<PersistedState> = { auth: AuthInitialState, data: DataInitialState, exercise: ExerciseInitialState, client: ClientInitialState };
        // Retrieve persisted state
        const auth = Storage.getJSON(AUTH_FEATURE_KEY) as AuthState;
        const data = Storage.getJSON(DATA_FEATURE_KEY) as DataState;
        const exercise = Storage.getJSON(EXERCISE_FEATURE_KEY) as ExerciseState;
        const client = Storage.getJSON(CLIENT_FEATURE_KEY) as ClientState;
        if (auth) persistedState['auth'] = auth as AuthState;
        if (data) persistedState['data'] = data as DataState;
        if (exercise) persistedState['exercise'] = exercise as ExerciseState;
        if (client) persistedState['client'] = client as ClientState;
        this.logger.debug(this.constructor.name, 'Rehydrated State', persistedState);
        return of(HydrationActions.hydrateSuccess({ state: persistedState }));
      }),
      catchError((error) => of(HydrationActions.hydrateFailure({ error })))
    )
  });
}
